import React from "react";

const styles = {
  error: {
    fontWeight: "bold",
    fontSize: 10,
    color: "red",
    textTransform: "capitalize"
  }
};

const ErrorField = ({ error }) => <p style={styles.error}>{error}</p>;

export default ErrorField;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/fields/error.js